import { ProfileButton } from "./ProfileButton";
import DollarHeartIcon from "../Icons/DollarHeartIcon";

export function LearnMoreButton(props) {
  return (
    <ProfileButton 
      classList="profile-button__learn-more"
      icon={<DollarHeartIcon />}
      handleClick={() => {
        // Include Click Handler Logic Here
      }}
      {...props}
    >
      Learn more
    </ProfileButton>
  );
}

export default LearnMoreButton;